import FlurryDataAccess from "../data/FlurryDataAccess";
import {getGlobal} from "reactn";
import {ArrayUtil} from "oca-lib-web";

export default class EventUtil {

    public static getParamValue(event:FlurryEventParamModel, paramName:string): string {
        return event.paramValue ? event.paramValue[paramName] : null;
    }

    public static hasParam(event:FlurryEventParamModel, paramName:string): boolean {
        return event.paramValue && event.paramValue[paramName];
    }

    public static getParams(event:FlurryEventParamModel): Array<string> {
        //console.log(event.paramValue);
        return event.paramValue && event.paramValue instanceof Object ? Object.keys(event.paramValue) : [];
        //return event.paramValue && event.paramValue.indexOf("{") > -1 && event.paramValue.indexOf("}") > -1
    }

    public static getParamNames(item:GraphSettings):Array<string> {
        let graphParams:Array<string> = [];
        let dataset:Array<FlurryEventParamModel> = [];
        if (item.dataSource === FlurryDataAccess.EVENTPARAMS) {
            dataset = getGlobal().flurry.eventParams;
        }

        if (dataset) {
            for (let dataItem of dataset) {
                let paramValues = EventUtil.getParams(dataItem);
                for (let paramValue of paramValues) {
                    if (!ArrayUtil.contains(graphParams, paramValue)) {
                        graphParams.push(paramValue);
                    }
                }
            }
        }
        return graphParams;
    }
}